// Croatian translations
export const hr: Record<string, string> = {
  'menu.dashboard': 'Nadzorna ploča',
  'menu.orderNew': 'Registracija proizvoda',
  'menu.customers': 'Kupci',
  'menu.products': 'Proizvodi',
  'menu.users': 'Korisnici',
  'menu.settings': 'Postavke',
  'menu.logout': 'Odjava',
  'dashboard.title': 'Nadzorna ploča',
  'dashboard.todaySales': 'Prodaja danas',
  'dashboard.totalOrders': 'Ukupno narudžbi',
  'dashboard.newOrder': 'Nova narudžba',
  'dashboard.newCustomer': 'Novi kupac',
  'order.title': 'Nova narudžba',
  'order.customer': 'Kupac',
  'order.products': 'Proizvodi',
  'order.quantity': 'Količina',
  'order.price': 'Cijena',
  'order.total': 'Ukupno',
  'order.payment': 'Plaćanje',
  'order.cash': 'Gotovina',
  'order.card': 'Kartica',
  'users.title': 'Korisnici',
  'users.name': 'Ime',
  'users.email': 'Email',
  'users.role': 'Uloga',
  'users.edit': 'Uredi',
  'users.delete': 'Obriši',
  'common.yes': 'Da',
  'common.no': 'Ne',
  'common.cancel': 'Odustani',
  'common.save': 'Spremi',
  'common.search': 'Pretraži',
  'common.loading': 'Učitavanje...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Prijava',
  'login.enterPin': 'Unesite PIN',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Registracija',
  'signup.createAccount': 'Kreiraj račun',
  'signup.email': 'Email',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Izvješća i računovodstvo',
  'menu.systemAndCommunication': 'Sustav i komunikacija',
};
